import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { PaymentType } from '../../../../../../api/types/settings/lecturers/settings-lecturers-rate-type';

export const createNewRatePriceForLecturerOperations = async (
  typeName: string,
  paymentType: PaymentType,
  closeDialog: () => void,
  setLoading: (isLoading: boolean) => void,
) => {
  if (typeName.length < 3) {
    toast.warn('על שם סוג השרות להיות לפחות שלוהש תווים');
    return;
  }
  try {
    // TODO api call
    setLoading(true);
    const res = await appApi.addRatingPriceRate(typeName, paymentType);
    globalSettingsStores.lecturersTypeRateNames.push(res.data.body);
    setLoading(false);
    toast.success('הפעולה בוצעה בהצלחה');
    closeDialog();
  } catch (e) {
    console.error(
      `createNewRatePriceForLecturerOperations is failed with the typeName: ${typeName} and the error: ${e}`,
    );
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים...');
  }
};
